import React, { useMemo } from 'react';
import { theme, Typography } from 'antd';
import { ArrowRightOutlined, RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { userStore } from '../features/auth';

const { Text } = Typography;

interface StoredUserProfile {
  email?: string;
  fullname?: string;
}

interface ProfileHeaderProps {
  onLogout: () => void;
  onClose?: () => void;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ onLogout, onClose }) => {
  const { token } = theme.useToken();
  const navigate = useNavigate();

  const user = useMemo(() => userStore.getUser() as StoredUserProfile | null, []);
  const handleProfileClick = () => {
    onClose?.();
    navigate('/profile');
  };

  return (
    <div className="flex flex-col px-2 bg-white border-gray-200 mb-4 mt-4">
      <div className="flex items-center gap-3">
        <div className="flex flex-col">
          <div className="flex items-center gap-2">
            <div className={`w-[4px] h-8 bg-gray-300 rounded-full`} style={{ backgroundColor: token.colorPrimary }}></div>
            <div className="flex flex-col">
              <div className="flex items-center gap-1 whitespace-nowrap cursor-pointer hover:text-primary" onClick={handleProfileClick}>
                <Text className="text-sm font-medium text-gray-800">{user?.fullname || 'N/A'}</Text>
                <RightOutlined className="ms-auto text-gray-600 text-primary" />
              </div>
              <Text className="text-xs text-gray-500">{user?.email || 'N/A'}</Text>
              <div className="flex items-center gap-1"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex gap-2 mt-8">
        <ArrowRightOutlined />
        <Text className="text-xs hover:text-grey-800 cursor-pointer transition-colors" onClick={onLogout}>
          Logout
        </Text>
      </div>
    </div>
  );
};

export default ProfileHeader;
